<div>
  <p>
    <b>Ocorrência climática de </b>{{registro.objeto.evento.descricao}}
  </p>
  <p>
    {{registro.objeto.situacao}}
  </p>
  <p ng-if="registro.dataRegistro">Data do Registro: {{registro.dataRegistro | date: 'dd/MM/yyyy'}}</p>
</div>
